<template>
  <WdsText class="tw-truncate">{{ clientName }}</WdsText>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'

// On the partner (EOR) payment requests view the client is the company on the
// bill's hire — the partner is that hire's employer of record.
const PaymentRequestClientColumn = graphql(`
  fragment PaymentRequestClientColumn on PaymentRequest {
    id
    hire {
      id
      company {
        id
        name
      }
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof PaymentRequestClientColumn> }>()
const column = computed(() => useFragment(PaymentRequestClientColumn, props.row))

const clientName = computed(() => column.value.hire?.company?.name || '—')
</script>

<style scoped></style>
